// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"815":"de1c4f1c","821":"40aaa42c"}[chunkId] + ".chunk.js";
};